import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addEditExportDetails  } from "../../redux/features/product.features";


const ProductEdit_ExportDetails = () => {
  const dispatch = useDispatch()
  let productState = useSelector((state) => {
    return state.productReducer;
  });
 
  let { exportDetails, loading , stepOne } = productState;
  let {weight} = stepOne;

  const initialValues = {
    exportMainCategory:"Green Sapphire",
    exportWeightRange: Number(weight) >= 3.00 ? "Big (+3)" : "Small (-3)"
}



  // const [values, setValues] = useState(exportDetails || initialValues);
  const [values, setValues] = useState(exportDetails.exportMainCategory ==="" ? initialValues: exportDetails);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(()=>{
    setValues({
      ...values,
      ["exportWeightRange"]:  Number(weight || 0) >= 3.00 ? "Big (+3)" : "Small (-3)",
    });
  },[weight])


const Verify = ()=>{
    const finalVal = {
        exportMainCategory:values.exportMainCategory,
       exportWeightRange:values.exportWeightRange
   }

   dispatch(addEditExportDetails(finalVal))
}
  useEffect(()=>{

    Verify()

  },[values])

  return (
    <div className="flex flex-col w-full h-full">
      Product  Export Details
      <div className="flex mt-4" style={{height:400}}> 
        <div className="flex">
          <CustomSelectBox
            style={{ width:300}}
            className=""
            items={["Ruby", "Blue Sapphire", "Green Sapphire", "Peach Sapphire", "Mix Sapphire", "Star Sapphire", "Padparadscha", "TSavorite", "Spinel", "Tourmaline", "Alexandrite", "Aquamarine", "Cats eye", "Garnet", "Precious", "Semi Precious"]}
            onChange={handleChange}
            title="exportMainCategory"
            name="exportMainCategory"
            value={values.exportMainCategory}
            selectedValue={values.exportMainCategory}
          />
        </div>
        <div className="flex">
          <CustomSelectBox
            style={{ width: 300 }}
            className=""
            items={["Big (+3)", "Small (-3)"]}
            onChange={handleChange}
            title="exportWeightRange"
            name="exportWeightRange"
            value={values.exportWeightRange}
            selectedValue={values.exportWeightRange}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductEdit_ExportDetails;
